import React from "react";
import { ContratoDetailsPage } from "./contratoDetails.page";
import { ContratoDetailsProvider } from "./context/contrato-details-context";

export function ContratoDetailsFactory() {
    return (
        <ContratoDetailsProvider>
            <ContratoDetailsPage />
        </ContratoDetailsProvider>
    );
}
